import { } from '@/api/requests';

const state = {
  categories: [],
  sections: [],
  blogs: [],
  blog: {},
};

const mutations = {
  setCategories(state, list) {
    state.categories = list;
  },

  setBlogs(state, list) {
    state.blogs = list;
  },

  setBlogDetails(state, details) {
    state.blog = details;
  },

  setSections(state, sections) {
    state.sections = sections;
  },
  
  addSection(state, type) {
    state.sections.push({ heading: '', body: '', doc_type: type, id: '', new: true });
  },

  updateNewSection(state, newSectionVals) {
    let section = state.sections.find(sec => sec.id === '');
    let index = state.sections.indexOf(section);
    state.sections[index] = newSectionVals;
  },

  deleteNewSection(state) {
    let section = state.sections.find(sec => sec.new === true);
    let index = state.sections.indexOf(section);
    state.sections.splice(index, 1);
  },

  deleteSection(state, id) {
    let section = state.sections.find(sec => sec.id === id);
    let index = state.sections.indexOf(section);
    state.sections.splice(index, 1);
  },

  deleteBlog(state, id) {
    let blog = state.blogs.find(b => b.id === id);
    let index = state.blogs.indexOf(blog);
    state.blogs.splice(index, 1);
  }
};

const actions = {
  setList(context, list) {
    context.commit('setCategories', list);
  },

  setBlogs(context, list) {
    context.commit('setBlogs', list);
  },

  setDetails(context, sections) {
    context.commit('setSections', sections);
  },

  setBlogDetails(context, details) {
    context.commit('setBlogDetails', details);
  },

  addSection(context, type) {
    context.commit('addSection', type);
  }
};

const getters = {

};

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};